import PropTypes from 'prop-types'
import React, { useState, useEffect} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaUpload} from "react-icons/fa"
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from "react-tooltip"



const Tag = ({ sessionID, color, info, notes, def }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const project = useDrop().currentDrop;

  useEffect(() => {
    setIsLoaded(true);
  }, [def]);

  if (!isLoaded) {
    return null;
  }

  var rand_id = Math.floor(Math.random() * 10000);
  rand_id = rand_id.toString();

  return (
    <button
    id={sessionID + info + rand_id}
    style={{
      backgroundColor: color,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "7px",
      width: "100%",
    }}
    className="btn"
    data-tooltip-content={"Definition: " + def}
  >
    <div style={{ justifyContent: "center" }}>
      {info}
      <ReactTooltip anchorId={sessionID + info + rand_id} />
    </div>
  </button>
);
};


Tag.defaultProps = {
  color: 'e7e7e7',
  sessionID: 837360280,
}

Tag.propTypes = { 
  sessionID: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default Tag